import { useEffect, useState } from "react";
import { Route, Switch, useLocation } from "wouter";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import BasketPage from "./pages/Basket";
import HistoryPage from "./pages/History";
import RewardsPage from "./pages/Rewards";
import PortfolioPage from "./pages/Portfolio";
import CyclesPage from "./pages/Cycles";
import LotteryPage from "./pages/Lottery";
import YieldPage from "./pages/Yield";
import CommunityPage from "./pages/Community";
import SwapPage from "./pages/Swap";
import DocsPage from "./pages/Docs";
import FaqPage from "./pages/Faq";
import TermsPage from "./pages/Terms";
import PrivacyPage from "./pages/Privacy";
import TokenPage from "./pages/Token";
import { loadIndexData } from "./lib/data";

export default function App() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loc] = useLocation();
  const isHome = loc === "/";

  useEffect(() => {
    loadIndexData()
      .then(setData)
      .catch((e) => setError(e.message));
  }, []);

  return (
    <>
      <div className="status-strip">
        <span className="status-dot" aria-hidden />
        <strong>LIVE BASKET</strong>
        {" · "}
        Stonksindex scores StonkFun markets and rotates holder rewards from
        $SI creator fees.
      </div>
      <div className={`app-frame${isHome ? " app-frame--home" : ""}`}>
        <Header />
        <main>
          {error && (
            <div className="shell">
              <p className="error">Could not load index data: {error}</p>
            </div>
          )}
          {!data && !error && (
            <div className="shell">
              <p className="loading">Loading Stonksindex…</p>
            </div>
          )}
          {data && (
            <Switch>
              <Route path="/">{() => <Home data={data} />}</Route>
              <Route path="/basket">{() => <BasketPage data={data} />}</Route>
              <Route path="/portfolio">{() => <PortfolioPage data={data} />}</Route>
              <Route path="/cycles">{() => <CyclesPage data={data} />}</Route>
              <Route path="/lottery">{() => <LotteryPage data={data} />}</Route>
              <Route path="/yield">{() => <YieldPage data={data} />}</Route>
              <Route path="/community">{() => <CommunityPage data={data} />}</Route>
              <Route path="/swap" component={SwapPage} />
              <Route path="/docs">{() => <DocsPage data={data} />}</Route>
              <Route path="/faq">{() => <FaqPage data={data} />}</Route>
              <Route path="/terms" component={TermsPage} />
              <Route path="/privacy" component={PrivacyPage} />
              <Route path="/history" component={HistoryPage} />
              <Route path="/rewards">{() => <RewardsPage data={data} />}</Route>
              <Route path="/token" component={TokenPage} />
              <Route>
                <div className="shell">
                  <p className="error">Page not found.</p>
                </div>
              </Route>
            </Switch>
          )}
        </main>
      </div>
      <Footer />
    </>
  );
}
